import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, TableCell ,Button,Modal} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import InfantIndicator from "../InfantIndicator";
import { ActionsMenu } from '../ActionsMenu'
import { isFlightOpen } from "../../util/isFlightOpen";
import { FlightTimeDisplay } from "../../util/FlightTimeDisplay";
import { PaxInfoResult } from '../PaxInfoResult';
import { StyledTableRow } from '../../util/StyledTableRow'
import SummaryModal from '../../modals/Summary';
import _ from 'lodash'
import { useSelector } from "react-redux";

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableCellLessPad: {
    padding: '10px'
  },
  mobileRowItem: {
    marginTop: '5px',
    marginBottom: '0px'
  }
});
const standbyStyle = {
  color: 'red',
  fontWeight: 'bold',
};

export const DesktopResult = (props) => {
  const {row, modalClasses, newTexts, date} = props;
  let hasStandbyPax = props.row.PaxList.match(/\- (SA|MM|PN)/g);
  let betterRow = typeof row === 'object' ? _.cloneDeep(row) : {}
  betterRow.status = isFlightOpen(betterRow)
  const [openSummary, setopenSummary] = useState(false);


  const rowItemClasses = useRowStyles();

  const handleOpenSummary = () => {
    setopenSummary(true);
  };
  const handleCloseSummary = () => {
    setopenSummary(false);
  };
  const [shouldOpenAccordion, setShouldOpenAccordion] = React.useState(false);
  const [openFlightIndex, setOpenFlightIndex] = React.useState(-1);

  const originState = useSelector((state) => state?.entities?.dcs?.origin);
  const destinationState = useSelector((state) => state?.entities?.dcs?.destination);
  const flightNoState = useSelector((state) => state?.entities?.dcs?.flightNumber);
  const TailNoState = useSelector((state) => state?.entities?.dcs?.tailNumber);
  const rlocState = useSelector((state) => state?.entities?.dcs?.rloc);
  const paxState = useSelector((state) => state?.entities?.dcs?.passenger);
  const statusState = useSelector((state) => state?.entities?.dcs?.status[0]);

  React.useEffect(() => {
    // Check if any filter except status filter is applied
    const origin =
      originState !== "None" ||
      destinationState !== "None" ||
      flightNoState !== "None" ||
      TailNoState !== "None" ||
      rlocState !== "" ||
      paxState !== "";

    // Update shouldOpenAccordion
    setShouldOpenAccordion(origin || openFlightIndex === row.index);
  }, [originState,
    destinationState,
    flightNoState,
    TailNoState,
    rlocState,
    paxState,
    statusState,
    openFlightIndex,
  ]);

  const handleAccordionClick = (index) => {
    if (index === openFlightIndex) {
      // Clicked on the same flight, close the accordion
      setOpenFlightIndex(-1);
      setShouldOpenAccordion(false); // Close the PaxInfoResult and arrow
    } else {
      // Clicked on a different flight, open its accordion
      setOpenFlightIndex(index);
      setShouldOpenAccordion(true); // Open the PaxInfoResult and arrow
    }
  };

  return (
    <React.Fragment>
      <StyledTableRow className={rowItemClasses.root}>
        <TableCell className={rowItemClasses.tableCellLessPad} style={{width: '11%'}}>
          <IconButton aria-label="expand row" size="small" onClick={() => handleAccordionClick(row.index)}>
            {openFlightIndex === row.index || shouldOpenAccordion ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {row.Load}{' '}{hasStandbyPax ? <span style={standbyStyle}>STBY</span> : ''}{' '}{hasStandbyPax ? `(${hasStandbyPax.length})` : ''}
          <InfantIndicator paxArr={row.passengers} isMobile={false} />
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          <ActionsMenu row={betterRow} date={date} modalClasses={modalClasses} />
        </TableCell>
        <TableCell component="th" scope="row" >
          <h4 style={{marginTop: '5px', marginBottom: '0px'}}>{row.FlightNumber}</h4>
          <p style={{marginTop: '5px', marginBottom: '0px'}}>{row.TailNumber}</p>
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
        <Button variant="contained" size="small" onClick={handleOpenSummary}>SUMMARY</Button>
        <Modal 
            open={openSummary} 
            onClose={handleCloseSummary} 
            aria-labelledby="simple-modal-title" 
            aria-describedby="simple-modal-description"
          >
             <SummaryModal pax={row} closeModal={handleCloseSummary} modalClasses={modalClasses} />
          </Modal>
      </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>{row.Origin}</TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          <FlightTimeDisplay type='dep' row={row} />
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          {row.Destination}
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          <FlightTimeDisplay type='arr' row={row} />
        </TableCell>
      </StyledTableRow>
      {(shouldOpenAccordion || openFlightIndex === row.index) && (
      <PaxInfoResult row={row} modalClasses={modalClasses} isMobile={false} openAccordion={shouldOpenAccordion || openFlightIndex === row.index} newTexts={newTexts} />
          )}
    </React.Fragment>
  )
}